import React from 'react';
import { HyperText } from '../components/HyperText';
import { MapPinIcon, PhoneIcon, MailIcon, ExternalLinkIcon } from 'lucide-react';
import { useDonateByMail } from '../contexts/DonateByMailContext';
const ContactPage = () => {
  const {
    openDonateByMail
  } = useDonateByMail();
  return <div className="w-full bg-white" data-id="element-463" data-mp="xp2stuqo8wdt">
      <div className="pt-40 sm:pt-48 md:pt-56 pb-12 sm:pb-16 md:pb-24" data-id="element-464" data-mp="xo17mxfxytid">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 text-center tracking-normal px-4" data-id="element-465" data-mp="zv5qiaemf7s">
          Contact Us
        </h1>
      </div>
      <div className="py-12 sm:py-16 md:py-24" data-id="element-466" data-mp="52i1uve3ymas">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-467" data-mp="9yqbjt9jdnak">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 sm:gap-16" data-id="element-468" data-mp="eyuudpxx2u3y">
            <div data-id="element-469" data-mp="ewrume6ypmm1">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8 sm:mb-10 tracking-normal" data-id="element-470" data-mp="1lex4wa362gx0">
                Get In Touch
              </h2>
              <div className="mb-12" data-id="element-471" data-mp="1qcq8cvd34wtl">
                <div className="flex items-start gap-4 mb-8" data-id="element-472" data-mp="1qfungns39cz1">
                  <MapPinIcon className="w-6 h-6 sm:w-7 sm:h-7 text-blue-500 flex-shrink-0 mt-1" data-id="element-473" data-mp="qzdfyro8a79v" />
                  <div data-id="element-474" data-mp="n0edretvsom4">
                    <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3 tracking-normal" data-id="element-475" data-mp="mwyyoc07jfkp">
                      Israeli Civilian Training Fund (ICTF)
                    </h3>
                  </div>
                </div>
              </div>
              <div className="bg-blue-50 p-8" data-id="element-476" data-mp="82ue8nfr7lnc">
                <h3 className="text-xl font-semibold text-gray-900 mb-6 tracking-normal" data-id="element-477" data-mp="83nhhefi7t0q">
                  How You Can Help
                </h3>
                <ul className="space-y-4" data-id="element-478" data-mp="3vfy70dujy716">
                  <li className="flex items-start" data-id="element-479" data-mp="3vcsdmmew4izn">
                    <span className="font-semibold text-blue-500 mr-2" data-id="element-480" data-mp="3qgv0sq2u5urm">
                      Give
                    </span>
                    <span className="text-gray-700" data-id="element-481" data-mp="3lg77fxr4x1u8">
                      Tax-deductible gifts through our U.S. 501(c)(3) Israeli
                      Civilian Training Fund{' '}
                      <span className="text-sm italic" data-id="element-482" data-mp="36t8mmlms95oh"></span>.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-483" data-mp="3buo6499bb44r">
                    <span className="font-semibold text-blue-500 mr-2" data-id="element-484" data-mp="2xtlm021vo3wh">
                      Partner
                    </span>
                    <span className="text-gray-700" data-id="element-485" data-mp="31vyqyo8svxs7">
                      Introduce corporate grants or in-kind equipment.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-486" data-mp="3uk4a56k7hepx">
                    <span className="font-semibold text-blue-500 mr-2" data-id="element-487" data-mp="3uit3myzdlsv4">
                      Share
                    </span>
                    <span className="text-gray-700" data-id="element-488" data-mp="3ktrpzfgaznkb">
                      Host an awareness event or share our story online.
                    </span>
                  </li>
                </ul>
                <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-489" data-mp="h4of8eyb8gyh">
                  <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="inline-block px-6 py-3 bg-blue-600 text-white font-medium rounded-lg border border-blue-600 hover:bg-blue-700 transition-colors text-center whitespace-nowrap" data-id="element-490" data-mp="h5zm4nn1y4tt">
                    Donate Online
                  </a>
                  <button type="button" onClick={openDonateByMail} className="inline-block px-6 py-3 bg-white text-blue-600 font-medium rounded-lg border border-blue-600 hover:bg-blue-50 transition-colors text-center whitespace-nowrap" data-id="element-491" data-mp="1ivpo3w27ne7j">
                    Donate by Mail
                  </button>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-8 sm:p-10 flex flex-col justify-center" data-id="element-492" data-mp="3480tl5kbis77">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 tracking-normal" data-id="element-493" data-mp="2z9fvbbommile">
                Send Us a Message
              </h2>
              <p className="text-gray-700 text-base sm:text-lg mb-8 leading-relaxed" data-id="element-494" data-mp="18vqbykp257bo">
                We'd love to hear from you. Click below to fill out our contact
                form and a member of our team will get back to you shortly.
              </p>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSd9WG42NcqW986ZXrVXt9w3yqegr-291VjOSCMUA-aSkzYx9A/viewform?usp=publish-editor" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-4 bg-israel-blue text-white font-semibold rounded-lg hover:bg-israel-blue-light transition-colors text-lg shadow-md w-full sm:w-auto" data-id="element-495" data-mp="1mty6klymfwjo">
                Open Contact Form
                <ExternalLinkIcon className="ml-2 w-5 h-5" data-id="element-496" data-mp="2ak25wh4s1a4v" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ContactPage;